export const INSIGHT_PERIOD_PRESETS = [
  'today',
  '7d',
  '30d',
  'qtd',
  'ytd',
] as const

export type InsightPeriodPreset = (typeof INSIGHT_PERIOD_PRESETS)[number]

/**
 * A custom period carries its own window as `custom:<from>:<to>` (local
 * `YYYY-MM-DD`), so the value stays a plain string and threads through tabs,
 * query params, and the export view exactly like a preset.
 */
export type InsightPeriod = InsightPeriodPreset | `custom:${string}`

export const INSIGHT_TABS = [
  'overview',
  'sales',
  'sources',
  'financials',
  'calls',
  'messaging',
  'activity',
] as const

export type InsightTab = (typeof INSIGHT_TABS)[number]

export const DEFAULT_INSIGHT_PERIOD: InsightPeriod = '30d'
export const DEFAULT_INSIGHT_TAB: InsightTab = 'overview'
